import { render, staticRenderFns } from "./QrcodeTfaConfig.vue?vue&type=template&id=0a4a3608&scoped=true"
import script from "./QrcodeTfaConfig.vue?vue&type=script&lang=js"
export * from "./QrcodeTfaConfig.vue?vue&type=script&lang=js"
import style0 from "./QrcodeTfaConfig.vue?vue&type=style&index=0&id=0a4a3608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4a3608",
  null
  
)

export default component.exports